// extracted by mini-css-extract-plugin
export default {"root":"PFlxEFf_Uc44cAw7Vkjd","info-message":"UV3ecIAvJtV0TZBwGRCt"};